var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBlueStarClicked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 63,
    viewBox: "0 0 64 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.1237 9.48523C36.657 2.90047 27.343 2.90045 24.8763 9.48523L20.7966 20.3758L9.89547 24.3604C3.23472 26.7951 3.23474 36.2154 9.89548 38.65L20.7966 42.6346L24.8763 53.5253C27.343 60.11 36.657 60.11 39.1237 53.5253L43.2034 42.6346L54.1045 38.65C60.7653 36.2154 60.7653 26.7951 54.1045 24.3604L43.2034 20.3758L39.1237 9.48523ZM43.2667 42.4655C43.2666 42.4657 43.2665 42.466 43.2664 42.4663L43.2667 42.4655ZM43.0337 20.3138C43.0339 20.3139 43.0341 20.314 43.0343 20.314L43.0337 20.3138Z",
    fill: "#7C97EF",
    stroke: "white",
    strokeWidth: 8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueStarClicked);
export default __webpack_public_path__ + "static/media/blueStarClicked.2beae17f97df2327ab3d365579c72ea7.svg";
export { ForwardRef as ReactComponent };